export default __webpack_public_path__ + "ea6a33320501204f3173ec0f144881b2.png";